var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle115(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "202.3123562645278 289.6650430991873 17.207643735472175 19.41659996733631",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M215.51,298.32c0,2.13-.39,3.81-1.54,5.22-1.63,2.01-4.42,2.08-6.03.06-1.77-2.22-2.08-4.8-1.01-7.38.72-1.74,2.26-2.63,4.19-2.55,1.94.08,3.25,1.15,4.01,2.87.28.64.31,1.4.39,1.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle115);
export default __webpack_public_path__ + "static/media/twinkle-1-15.6d7be39067d8e2979ee6b336f7d73f0e.svg";
export { ForwardRef as ReactComponent };